import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { useJourneyNavigate } from '@/services/journeys/useJourneyNavigate';

import { useValidateTransactionPending } from './useValidateTransactionPending';
import { clearErrorMessage } from './transactionSlice';

// Components
import PaymentErrorText from './PaymentErrorText';
import {
  ColouredBackground, StyledHeading, StyledText, StyledButton
} from './PaymentStyles.style';

function PaymentError() {
  const dispatch = useAppDispatch();
  const journeysState = useAppSelector(state => state.journeys);
  const paymentSelectState = useAppSelector(state => state.paymentSelect);

  const journeyNavigate = useJourneyNavigate();

  // Validate state is as expected, otherwise redirect to index
  useValidateTransactionPending();

  const restartPayment = () => {
    dispatch(clearErrorMessage());
    // For direct payments, navigate back to the specific transaction URL, we don't allow users to navigate to the root of the site
    if (journeysState.journey === 'direct' && paymentSelectState.fixedTransactionId) {
      window.location.href = `/pay/${paymentSelectState.fixedTransactionId}`;
    } else {
      // For normal journeys, use the standard restart flow
      journeyNavigate('restart');
    }
  };

  return (
    <ColouredBackground>
      <StyledHeading tag="h1" family="Anton" size="xl" color="black" uppercase>Payment Error</StyledHeading>

      <PaymentErrorText />

      <StyledText tag="p" family="Montserrat" size="md" color="black">
        An error has occurred. We are sorry for the inconvenience.
      </StyledText>

      <StyledButton
        type="submit"
        onClick={restartPayment}
      >
        Start again...
      </StyledButton>

    </ColouredBackground>
  );
}

export default PaymentError;
